import { ReactComponent as ArrowDown } from 'images/arrowDown.svg';
import { ReactComponent as ArrowUp } from 'images/arrowUp.svg';
import { COLORS } from 'pages/Finance/CumulativeReport/components/CumulativeReportDatagrid/constants/colors';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { CumulativeReport } from 'types/embedded/cumulativeReport';
import { formatCurrency } from 'utils';

type Props = {
  valueKey: keyof CumulativeReport;
} & Omit<FunctionFieldProps, 'render'>;

export const CumulativeReportDatagridTotalField: React.FC<Props> = ({ label, valueKey }) => {
  return (
    <FunctionField
      label={label}
      render={(record: CumulativeReport) => {
        const isNegative = record?.totalAmount[0] === '-';

        return (
          <Stack direction="column">
            <Box sx={{ textWrap: 'nowrap' }}>
              {isNegative ? <ArrowDown /> : <ArrowUp />}
              <Typography
                color={isNegative ? COLORS.red : COLORS.green}
                component="span"
                fontSize={14}
              >
                {' '}
                {formatCurrency(Number(record[valueKey]))}
              </Typography>
            </Box>
          </Stack>
        );
      }}
    />
  );
};
